import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { PartnerSite } from '../../entities/control-tables/partner-site-entity';

export class PartnerSiteRequest extends BaseRequest{
  partnerSite : PartnerSite;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.partnerSite = new PartnerSite();
  }
}